// extracted by mini-css-extract-plugin
export default {"container":"DivisionTabs_container_a8c14","divisionNumber":"DivisionTabs_divisionNumber_f5b93","smallText":"DivisionTabs_smallText_de48b"};